<template>
    <div class="col-span-3 p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800">
        <!-- Card header -->
        <div class="items-center justify-between lg:flex">
            <div class="mb-4 lg:mb-0">
                <h3 class="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                    {{ getLabel() }}
                </h3>
                <span class="text-base font-normal text-gray-500 dark:text-gray-400">
                    Đây là danh sách các hoạt động mới nhất
                </span>
            </div>

            <!--      TO DO SEARCH -->
            <!--      <div class="items-center sm:flex"> -->
            <!--        <div class="flex items-center"> -->
            <!--          <button -->
            <!--            id="dropdownDefault" -->
            <!--            data-dropdown-toggle="dropdown" -->
            <!--            class="mb-4 sm:mb-0 -->
            <!--            mr-4 inline-flex items-center -->
            <!--            text-gray-900 bg-white border -->
            <!--            border-gray-300 focus:outline-none -->
            <!--            hover:bg-gray-100 focus:ring-4 -->
            <!--            focus:ring-gray-200 font-medium -->
            <!--            rounded-lg text-sm px-4 py-2.5 -->
            <!--            dark:bg-gray-800 dark:text-white -->
            <!--            dark:border-gray-600 dark:hover:bg-gray-700 -->
            <!--            dark:hover:border-gray-600 dark:focus:ring-gray-700" -->
            <!--            type="button" -->
            <!--          > -->
            <!--            Filter by status -->
            <!--            <svg -->
            <!--              class="w-4 h-4 ml-2" -->
            <!--              aria-hidden="true" -->
            <!--              fill="none" -->
            <!--              stroke="currentColor" -->
            <!--              viewBox="0 0 24 24" -->
            <!--              xmlns="http://www.w3.org/2000/svg" -->
            <!--            > -->
            <!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /> -->
            <!--            </svg> -->
            <!--          </button> -->
            <!--          &lt;!&ndash; Dropdown menu &ndash;&gt; -->
            <!--          <div -->
            <!--            id="dropdown" -->
            <!--            class="z-10 hidden -->
            <!--               w-56 p-3 bg-white -->
            <!--               rounded-lg shadow dark:bg-gray-700" -->
            <!--            data-popper-placement="bottom" -->
            <!--            style="position: absolute; -->
            <!--               inset: 0px auto auto 0px; margin: 0px; transform: translate3d(948px, 3056px, 0px);" -->
            <!--          > -->
            <!--            <h6 class="mb-3 text-sm font-medium text-gray-900 dark:text-white"> -->
            <!--              Category -->
            <!--            </h6> -->
            <!--            <ul class="space-y-2 text-sm" aria-labelledby="dropdownDefault"> -->
            <!--              <li class="flex items-center"> -->
            <!--                <input -->
            <!--                  id="apple" -->
            <!--                  type="checkbox" -->
            <!--                  value="" -->
            <!--                  class="w-4 h-4 bg-gray-100 -->
            <!--                       border-gray-300 rounded text-primary-600 -->
            <!--                       focus:ring-primary-500 dark:focus:ring-primary-600 -->
            <!--                       dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" -->
            <!--                > -->

            <!--                <label for="apple" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100"> -->
            <!--                  Completed (56) -->
            <!--                </label> -->
            <!--              </li> -->

            <!--              <li class="flex items-center"> -->
            <!--                <input -->
            <!--                  id="fitbit" -->
            <!--                  type="checkbox" -->
            <!--                  value="" -->
            <!--                  checked="" -->
            <!--                  class="w-4 h-4 bg-gray-100 border-gray-300 -->
            <!--                       rounded text-primary-600 focus:ring-primary-500 -->
            <!--                       dark:focus:ring-primary-600 dark:ring-offset-gray-700 -->
            <!--                       focus:ring-2 dark:bg-gray-600 dark:border-gray-500" -->
            <!--                > -->

            <!--                <label for="fitbit" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100"> -->
            <!--                  Cancelled (56) -->
            <!--                </label> -->
            <!--              </li> -->

            <!--              <li class="flex items-center"> -->
            <!--                <input id="dell" type="checkbox" value="" class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"> -->

            <!--                <label for="dell" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100"> -->
            <!--                  In progress (56) -->
            <!--                </label> -->
            <!--              </li> -->

            <!--              <li class="flex items-center"> -->
            <!--                <input id="asus" type="checkbox" value="" checked="" class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"> -->

            <!--                <label for="asus" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100"> -->
            <!--                  In review (97) -->
            <!--                </label> -->
            <!--              </li> -->
            <!--            </ul> -->
            <!--          </div> -->
            <!--        </div> -->
            <!--        <div date-rangepicker="" class="flex items-center space-x-4"> -->
            <!--          <div class="relative"> -->
            <!--            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"> -->
            <!--              <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"> -->
            <!--                <path -->
            <!--                  d="M5.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H6a.75.75 0 01-.75-.75V12zM6 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H6zM7.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H8a.75.75 0 01-.75-.75V12zM8 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H8zM9.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V10zM10 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H10zM9.25 14a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V14zM12 9.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V10a.75.75 0 00-.75-.75H12zM11.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H12a.75.75 0 01-.75-.75V12zM12 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H12zM13.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H14a.75.75 0 01-.75-.75V10zM14 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H14z" -->
            <!--                /> -->
            <!--                <path -->
            <!--                  clip-rule="evenodd" -->
            <!--                  fill-rule="evenodd" -->
            <!--                  d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" -->
            <!--                /> -->
            <!--              </svg> -->
            <!--            </div> -->
            <!--            <input -->
            <!--              name="start" -->
            <!--              type="text" -->
            <!--              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 datepicker-input" -->
            <!--              placeholder="From" -->
            <!--            > -->
            <!--          </div> -->
            <!--          <div class="relative"> -->
            <!--            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"> -->
            <!--              <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"> -->
            <!--                <path -->
            <!--                  d="M5.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H6a.75.75 0 01-.75-.75V12zM6 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H6zM7.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H8a.75.75 0 01-.75-.75V12zM8 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H8zM9.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V10zM10 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H10zM9.25 14a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H10a.75.75 0 01-.75-.75V14zM12 9.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V10a.75.75 0 00-.75-.75H12zM11.25 12a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H12a.75.75 0 01-.75-.75V12zM12 13.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V14a.75.75 0 00-.75-.75H12zM13.25 10a.75.75 0 01.75-.75h.01a.75.75 0 01.75.75v.01a.75.75 0 01-.75.75H14a.75.75 0 01-.75-.75V10zM14 11.25a.75.75 0 00-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H14z" -->
            <!--                /> -->
            <!--                <path -->
            <!--                  clip-rule="evenodd" -->
            <!--                  fill-rule="evenodd" -->
            <!--                  d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" -->
            <!--                /> -->
            <!--              </svg> -->
            <!--            </div> -->
            <!--            <input -->
            <!--              name="end" -->
            <!--              type="text" -->
            <!--              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 datepicker-input" -->
            <!--              placeholder="To" -->
            <!--            > -->
            <!--          </div> -->
            <!--        </div> -->
            <!--      </div> -->
        </div>
        <!-- Table -->
        <div class="flex flex-col mt-6">
            <div class="overflow-x-auto rounded-lg">
                <div class="inline-block min-w-full align-middle">
                    <div class="overflow-hidden shadow sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
                            <thead class="bg-gray-50 dark:bg-gray-700">
                                <tr>
                                    <th
                                        v-for="(header, index) in CHeaderDefault"
                                        :key="index"
                                        scope="col"
                                        class="p-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase dark:text-white">
                                        {{ header.headerName }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white dark:bg-gray-800">
                                <tr
                                    v-for="(item, index) in dataReportDetailTable"
                                    :key="index">
                                    <td
                                        v-for="(headerItem, indexHeader) in CHeaderDefault"
                                        :key="indexHeader"
                                        class="p-4 text-sm font-normal text-gray-900 whitespace-nowrap dark:text-white">
                                        <div v-if="headerItem.key === 'status'">
                                            <status
                                                :status="getValue(item, headerItem)"
                                                :module="module" />
                                        </div>
                                        <span v-else>
                                            {{ getValue(item, headerItem) }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    <!-- Card Footer -->
    <!--    <div class="flex items-center justify-between pt-3 sm:pt-6"> -->
    <!--      <div> -->
    <!--        <button class="inline-flex items-center p-2 text-sm font-medium text-center text-gray-500 rounded-lg hover:text-gray-900 dark:text-gray-400 dark:hover:text-white" type="button" data-dropdown-toggle="transactions-dropdown"> -->
    <!--          Last 7 days -->
    <!--          <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> -->
    <!--            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /> -->
    <!--          </svg> -->
    <!--        </button> -->
    <!--        &lt;!&ndash; Dropdown menu &ndash;&gt; -->
    <!--        <div -->
    <!--          id="transactions-dropdown" -->
    <!--          class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600" -->
    <!--          data-popper-reference-hidden="" -->
    <!--          data-popper-escaped="" -->
    <!--          data-popper-placement="top" -->
    <!--          style="position: absolute; inset: auto auto 0px 0px; margin: 0px; transform: translate3d(354.667px, 2847.33px, 0px);" -->
    <!--        > -->
    <!--          <div class="px-4 py-3" role="none"> -->
    <!--            <p class="text-sm font-medium text-gray-900 truncate dark:text-white" role="none"> -->
    <!--              Sep 16, 2021 - Sep 22, 2021 -->
    <!--            </p> -->
    <!--          </div> -->
    <!--          <ul class="py-1" role="none"> -->
    <!--            <li> -->
    <!--              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Yesterday</a> -->
    <!--            </li> -->
    <!--            <li> -->
    <!--              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Today</a> -->
    <!--            </li> -->
    <!--            <li> -->
    <!--              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Last 7 days</a> -->
    <!--            </li> -->
    <!--            <li> -->
    <!--              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Last 30 days</a> -->
    <!--            </li> -->
    <!--            <li> -->
    <!--              <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Last 90 days</a> -->
    <!--            </li> -->
    <!--          </ul> -->
    <!--          <div class="py-1" role="none"> -->
    <!--            <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Custom...</a> -->
    <!--          </div> -->
    <!--        </div> -->
    <!--      </div> -->
    <!--      <div class="flex-shrink-0"> -->
    <!--        <a href="#" class="inline-flex items-center p-2 text-xs font-medium uppercase rounded-lg text-primary-700 sm:text-sm hover:bg-gray-100 dark:text-primary-500 dark:hover:bg-gray-700"> -->
    <!--          Transactions Report -->
    <!--          <svg class="w-4 h-4 ml-1 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> -->
    <!--            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /> -->
    <!--          </svg> -->
    <!--        </a> -->
    <!--      </div> -->
    <!--    </div> -->
    </div>
</template>

<script lang="ts" setup>
import Status from './status.vue'
import { $lodash } from '#imports'
const props = defineProps({
  module: {
    type: String,
    required: true
  },
  headers: {
    type: Object,
    required: true
  }
})

const { module, headers } = toRefs(props)
const { $formatters } = useNuxtApp()

const CHeaderDefault = computed(() => {
  switch (module.value) {
  case 'vehicles':
    return [
      {
        headerName: $t('labels.vehicleModule.licensePlate'),
        key: 'licensePlate'
      },
      {
        headerName: $t('status'),
        key: 'status'
      },
      {
        field: 'createdAt',
        headerName: $t('labels.createdAt'),
        valueGetter: (params: any) => {
          if (params.createdAt) {
            return $formatters.datetime(params.createdAt)
          }
        }
      },
      {
        field: 'updatedAt',
        headerName: $t('labels.updatedAt'),
        valueGetter: (params: any) => {
          if (params.updatedAt) {
            return $formatters.datetime(params.updatedAt)
          }
        }
      }
    ]
  case 'driver':
    return [
      {
        headerName: $t('labels.fullName'),
        key: 'fullName'
      },
      {
        headerName: $t('labels.status'),
        key: 'status'
      },
      {
        field: 'createdAt',
        headerName: $t('labels.createdAt'),
        valueGetter: (params: any) => {
          if (params.createdAt) {
            return $formatters.datetime(params.createdAt)
          }
        }
      },
      {
        field: 'updatedAt',
        headerName: $t('labels.updatedAt'),
        valueGetter: (params: any) => {
          if (params.updatedAt) {
            return $formatters.datetime(params.updatedAt)
          }
        }
      }
    ]
  case 'order':
    return [
      {
        headerName: $t('labels.code'),
        key: 'code'
      },
      {
        headerName: $t('labels.status'),
        key: 'status'
      },
      {
        field: 'createdAt',
        headerName: $t('labels.createdAt'),
        valueGetter: (params: any) => {
          if (params.createdAt) {
            return $formatters.datetime(params.createdAt)
          }
        }
      },
      {
        field: 'updatedAt',
        headerName: $t('labels.updatedAt'),
        valueGetter: (params: any) => {
          if (params.updatedAt) {
            return $formatters.datetime(params.updatedAt)
          }
        }
      }
    ]
  case 'quote':
    return [
      {
        headerName: $t('labels.code'),
        key: 'code'
      },
      {
        headerName: $t('labels.status'),
        key: 'status'
      },
      {
        field: 'createdAt',
        headerName: $t('labels.createdAt'),
        valueGetter: (params: any) => {
          if (params.createdAt) {
            return $formatters.datetime(params.createdAt)
          }
        }
      },
      {
        field: 'updatedAt',
        headerName: $t('labels.updatedAt'),
        valueGetter: (params: any) => {
          if (params.updatedAt) {
            return $formatters.datetime(params.updatedAt)
          }
        }
      }
    ]
  case 'quoteRequest':
    return [
      {
        headerName: $t('labels.code'),
        key: 'code'
      },
      {
        headerName: $t('labels.status'),
        key: 'status'
      },
      {
        field: 'createdAt',
        headerName: $t('labels.createdAt'),
        valueGetter: (params: any) => {
          if (params.createdAt) {
            return $formatters.datetime(params.createdAt)
          }
        }
      },
      {
        field: 'updatedAt',
        headerName: $t('labels.updatedAt'),
        valueGetter: (params: any) => {
          if (params.updatedAt) {
            return $formatters.datetime(params.updatedAt)
          }
        }
      }
    ]
  }
})

const dataReportDetailTable = ref([])

const getStatistic = async () => {
  const api = $url.statistic.getStatistic
  const res = await $api(api, {
    uriParams: {
      CLASS: module.value
    },
    params: {
      typeReport: 'work'
    }
  })
  const resData: any = res?.data.value
  if (resData?.success) {
    dataReportDetailTable.value = resData.data.work
  }
  return null
}

onBeforeMount(async () => {
  await getStatistic()
})

const getValue = (item: { [key: string]: any }, header: { [key: string]: any }) => {
  if (typeof header.valueGetter === 'function') {
    return header.valueGetter(item)
  }
  return $lodash.get(item, header.key)
}

const getLabel = () => {
  switch (module.value) {
  case 'vehicles':
    return 'Hoạt động của xe'
  case 'driver':
    return 'Hoạt động của tài xế'
  case 'order':
    return 'Hoạt động của đơn hàng'
  case 'quote':
    return 'Hoạt động của báo giá'
  case 'quoteRequest':
    return 'Hoạt động của yêu cầu báo giá'
  default:
    return 'Unknown'
  }
}
</script>

<style scoped></style>
